export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/top_strategy_segment-b846849a8f8fa49c6fcda640e7b72a6b.svg";